import { FeedbackQuestion } from "~skillBuilder/components";

export const SECFeedback = [
  // Feedback Question 1
  {
    attribute: "special-education-classrooms/feedback",
    label: "Was the Special Education Classrooms content helpful?",
    answerType: {
      type: "CHOICE",
      options: [
        { label: "Yes", value: "yes", icon: { name: "Thumb Up", color: "black" } },
        { label: "No", value: "no", icon: { name: "Thumb Down", color: "black" } },
      ],
    },
    isRequired: true,
  },
  // Feedback Question 2
  {
    attribute: "special-education-classrooms/comments",
    label: "Tell us more of what you'd like to see (optional)",
    answerType: {
      type: "TEXT",
      placeholder: "Response",
    },
  },
] as const satisfies Array<FeedbackQuestion>;
